#import "./AnnotationSetDetails.graphql"
query BarMitzvahAnnotationsQuery($username: String!) {
  barMitzvahAnnotations(username: $username) {
    ...annotationSetDetails
  }
}
